import { useRef, useEffect, useReducer } from 'react';

import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { getReducer } from '../../utils';

import TopBar from './TopBar';
import Header from './Header';
import Network from './Network';
import Footer from './Footer';
import GoTop from './GoTop';

import LoadingBox from '../compoment/LoadingBox';
import MessageBox from '../compoment/MessageBox';

import getValue from '../../format/getValue';
import contact from '../../data/layouts/contact';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_COMPANY':
      return { ...state, infoCompany: action.payload, loading: false };
    case 'FETCH_SUCCESS_MENU':
      return { ...state, navigationMenu: action.payload, loading: false };
    case 'FETCH_SUCCESS_FOOTER':
      return { ...state, infoFooter: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
const MainLayout = ({ children }) => {
  const [
    { loading, error, navigationMenu, infoCompany, infoFooter },
    dispatch,
  ] = useReducer(getReducer(reducer), {
    infoFooter: [],
    infoCompany: [],
    navigationMenu: [],
    loading: true,
    error: '',
  });

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      if (hasFetchedRef.current) return;
      hasFetchedRef.current = true;
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPageSection = await axios.get('/page-section/public/shows');

        const infoCompany = resultPageSection.data.data.find(
          (item) => item.sectionType === 'infoCompany'
        )?.content;

        dispatch({ type: 'FETCH_SUCCESS_COMPANY', payload: infoCompany });

        const infoFooter = resultPageSection.data.data.find(
          (item) => item.sectionType === 'footer'
        )?.content;

        dispatch({ type: 'FETCH_SUCCESS_FOOTER', payload: infoFooter });

        const resultMenu = await axios.get('/navigation/public/shows');

        const menuItems = resultMenu.data.data.filter(
          (item) => item.parentId === null
        );

        dispatch({ type: 'FETCH_SUCCESS_MENU', payload: menuItems });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, []);

  const nameCompany = getValue(infoCompany, 'name');
  const workingFulltime = getValue(infoCompany, 'working_fulltime');
  const numberPhone = getValue(infoCompany, 'number_phone');

  const infoKeys = [
    { key: 'address', icon: 'footer-8.png' },
    { key: 'number_phone', icon: 'Header01-02-8.png' },
    { key: 'working_parttime', icon: 'clock.png' },
    { key: 'time_service', icon: 'phuc-vu.png' },
    { key: 'email', icon: 'email.png' },
  ];

  const contactItems = infoKeys
    .map(({ key, icon }) => ({ icon, data: getValue(infoCompany, key) }))
    .filter((item) => item.data?.value);

  const combinedData = contact.networks.map((network) => {
    try {
      const companyInfo = infoCompany.find(
        (item) => item.title === network.name
      );

      return {
        ...network,
        value: companyInfo ? companyInfo.value : '',
        url: companyInfo ? companyInfo.url : '',
      };
    } catch (error) {
      return { ...network, value: '', url: '' };
    }
  });

  const enrollment = navigationMenu.find((nav) => nav.title === 'Tuyển dụng');

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <div className="App">
      <ToastContainer position="top-right" limit={1} />

      <TopBar
        numberPhone={numberPhone}
        workingFulltime={workingFulltime}
        combinedData={combinedData}
        enrollment={enrollment}
      />
      <Header navigationMenu={navigationMenu} />
      <main className="content-show">{children}</main>
      <Network combinedData={combinedData} numberPhone={numberPhone} />

      <Footer
        infoCompany={infoCompany}
        contactItems={contactItems}
        combinedData={combinedData}
        infoFooter={infoFooter}
      />

      <GoTop />
    </div>
  );
};

export default MainLayout;
